const FormatActivité = (activité, lang) => {
    if(!activité) return "";

    let activitéArray = activité.split(";");
    activitéArray = activitéArray.map(_activité => {
        if(lang === "fr"){
            switch(_activité){
                case "Donneur d'ordre":
                    return "Donneur d'ordre /prescripteur";
                case "Créateur - Architecte":
                    return "Architecte";
                case "Créateur - Designer objet":
                    return "Designer objet";
                case "Créateur - Designer espace":
                    return "Architecte d'intérieur";
                case "Créateur - Graphiste":
                    return "Graphiste";
                case "Créateur - Scénographe":
                    return "Scénographe";
                case "Créateur - Stratégie de marque":
                    return "Créateur Stratégie de marque";
                case "Créateur - Stratégie digitale":
                    return "Créateur Stratégie digitale";
                case "Producteur -  Galerie":
                    return "Galeriste";
                case "Producteur - Equipementier / Matériaux":
                    return "Équipementier / matériaux";
                case "Producteur - Agenceur":
                    return "Agenceur";
                case "Producteur - Artisan d'art":
                    return "Artisan d'art";
                case "Producteur - Editeur":
                    return "Éditeur";
                case "Producteur - Fabricant":
                    return "Fabricant";
                case "Producteur - Distributeur":
                    return "Distributeur";
                case "Producteur - Autres":
                    return "Autre";
                case "Presse":
                    return "Presse";
                case "Institutionnel":
                    return "Institutionnel";
                case "Institutionnel - Ecole":
                    return "Institutionnel - école";
                case "Institutionnel - Consulat / ambassade":
                    return "Institutionnel - consulat / ambassade";
                case "Institutionnel - Musée / centre d'art":
                    return "Institutionnel - musée / centre d'art";
                case "Institutionnel - Salon / foire":
                    return "Institutionnel - salon / foire";
                default:
                    return "Autre";
            }
        }else{
            switch(_activité){
                case "Donneur d'ordre":
                    return "Client / prescriber";
                case "Créateur - Architecte":
                    return "Architect";
                case "Créateur - Designer objet":
                    return "Object designer";
                case "Créateur - Designer espace":
                    return "Interior designer";
                case "Créateur - Graphiste":
                    return "Graphic designer";
                case "Créateur - Scénographe":
                    return "Set designer";
                case "Créateur - Stratégie de marque":
                    return "Brand strategy designer";
                case "Créateur - Stratégie digitale":
                    return "Digital strategy designer";
                case "Producteur -  Galerie":
                    return "Gallery";
                case "Producteur - Equipementier / Matériaux":
                    return "Equipment / materials";
                case "Producteur - Agenceur":
                    return "Fitter";
                case "Producteur - Artisan d'art":
                    return "Craftsman";
                case "Producteur - Editeur":
                    return "Editor";
                case "Producteur - Fabricant":
                    return "Manufacturer";
                case "Producteur - Distributeur":
                    return "Distributor";
                case "Producteur - Autres":
                    return "Other";
                case "Presse":
                    return "Press";
                case "Institutionnel":
                    return "Institutional";
                case "Institutionnel - Ecole":
                    return "Institutional - school";
                case "Institutionnel - Consulat / ambassade":
                    return "Institutional - consulate / embassy";
                case "Institutionnel - Musée / centre d'art":
                    return "Institutional - museum / art center";
                case "Institutionnel - Salon / foire":
                    return "Institutional - trade show / fair";
                default:
                    return "Other";
            }
        }
    });

    return activitéArray.join(", ");
}
export default FormatActivité;